// src/utils/priceUtils.js

// A price is set when it's a number of 0 or more — 0 is a valid (free) price, only blank/negative isn't
export const hasPrice = (value) =>
  value !== '' && value !== null && value !== undefined &&
  !Number.isNaN(parseFloat(value)) && parseFloat(value) >= 0;
